import React from 'react';
import Language from './Language';
import { getActiveLanguage, getSectionFromUrl } from '../../../../utilites/util';
import Menu from './Menu';
import Items from '../Items';
import Consumers from '../../../../constants/Consumers';
import Languages from '../../../../constants/Languages';

interface Props {
  header: any;
  showMenuItems: (item: any, isLogin: boolean) => {};
  selectedMenuItem: any;
  loginInfo: any;
  changeLanguage: (lang: string) => void;
  handleOnClick?: () => void;
}

const DesktopHeader: React.FC<Props> = ({
  header,
  showMenuItems,
  selectedMenuItem,
  loginInfo,
  changeLanguage,
  handleOnClick,
}) => {
  const isConsumer = getSectionFromUrl() === Consumers.PRIVATE_CONSUMER;
  const language = getActiveLanguage();
  const handleMenuOnClick = (item: any, isLogin: boolean) => {
    if (!item.items.length) {
      window.location.href = item.redirectTo;
      return window.location.href;
    }

    return showMenuItems(item, isLogin);
  };

  return (
    <div id="desktop-menu">
      <div className="d-flex">
        <div className="offset-3 col-9 text-end first-level-row header-pr">
          <Items
            isDesktop={true}
            activeItem={header.item}
            items={header.genericLinks}
            cssClasses="no-child list-item first-level"
            handleOnClick={handleOnClick}
            isLogin={false}
          />{' '}
          {isConsumer && language === Languages.SR && (
            <a
              style={{ color: '#002340' }}
              className="no-child list-item first-level yettel-light-font"
              href="https://www.yettel.rs/sr/privatni/podrska"
            >
              <span>| Kontakt i Podrška |</span>
            </a>
          )}
          <Language activeLanguage={getActiveLanguage()} changeLanguage={changeLanguage} />
        </div>
      </div>

      {Boolean(Object.keys(header.item).length) && (
        <Menu
          isDesktop={true}
          selectedItems={selectedMenuItem}
          items={header.item.items}
          handleOnClick={handleMenuOnClick}
          loginInfo={loginInfo}
        />
      )}
    </div>
  );
};

export default DesktopHeader;
